import Badge from '@components/atoms/Badge'
import type { IconTypes } from '@components/utils/Icon'
import { scopedTranslation } from '@utils/I18n'

const t = scopedTranslation('comms_management.blasts_index')

type BlastStatus = 'draft' | 'awaiting approval' | 'approved' | 'scheduled' | 'sent' | 'failed'

const TONE: Record<BlastStatus, 'muted' | 'warning' | 'info' | 'success' | 'error'> = {
  draft: 'muted',
  'awaiting approval': 'warning',
  approved: 'info',
  scheduled: 'info',
  sent: 'success',
  failed: 'error',
}

const ICON: Record<BlastStatus, IconTypes> = {
  draft: 'file-05',
  'awaiting approval': 'clock',
  approved: 'check',
  scheduled: 'calendar',
  sent: 'check-circle',
  failed: 'alert-circle',
}

export const blastStatusLabel = (status: BlastStatus) => t(`status.${status.replace(' ', '_')}`)

export function BlastStatusBadge({ status, detail }: { status: BlastStatus; detail?: string }) {
  return (
    <Badge color={TONE[status]} leadingIcon={ICON[status]} className="tw:whitespace-nowrap">
      {detail ? `${blastStatusLabel(status)} ${detail}` : blastStatusLabel(status)}
    </Badge>
  )
}
